import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Event } from '../../interfaces/event';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ButtonComponent } from '../button/button.component';
import { faCalendarAlt, faMapMarkerAlt, faMap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-event-card',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonComponent, FontAwesomeModule],
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss']
})
export class EventCardComponent {
  @Input() event: Event | undefined;
  @Input() cardMode: boolean = false;
  @Output() mapClick = new EventEmitter<number>();
  
  faCalendarAlt = faCalendarAlt;
  faMapMarkerAlt = faMapMarkerAlt;
  faMap = faMap;
  showAll = false;

  constructor(private router: Router) {}

  goToEvent() {
    this.router.navigate(['/event', this.event?.slug]);
  }

  get eventLocation(): string {
    if (this.event?.locationType === 2 && this.event.address) {
      return this.event.address;
    }
    if (this.event?.eventBranches && this.event.eventBranches.length > 0) {
      const count = this.event.eventBranches.length;
      return `${count} ${count === 1 ? 'sucursal' : 'sucursales'}`;
    }
    return '';
  }

  get finalPrice(): number {
    if (!this.event) return 0;
    return this.event.price - (this.event.discountAmount || 0);
  }

  get hasDiscount(): boolean {
    return !!this.event && this.event.discountAmount > 0;
  }
}
